import { RequestService } from '../../../../common/services/RequestService';
import { GET_EMPLOYEES } from '../constants';
import { adjustDriversData } from './adjustDriversData';

export const getDriversRequest = async currentProfileId => {
  const response = await RequestService.get(GET_EMPLOYEES + currentProfileId);
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data
      .filter(
        employee =>
          employee.roleId.roleKey === 'driver' &&
          employee.profileStatusId &&
          employee.profileStatusId.profileStatusKey === 'active'
      )
      .map(driver => adjustDriversData(driver))
  );
};
